<style scoped>
.resignation-wrap {
  width: 1200px;
  background: #fff;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 30px;
  padding-bottom: 30px;
  text-align: left;
  padding-left: 25px;
  box-sizing: border-box;
}
.resignation-title {
  position: relative;
  height: 74px;
  line-height: 74px;
  text-align: center;
  color: #232323;
  font-size: 20px;
  margin-right: 25px;
  box-sizing: border-box;
  border-bottom: 1px solid #dcdee0;
}
.resignation-title span {
  position: absolute;
  top: 50%;
  right: 0;
  width: 68px;
  height: 32px;
  line-height: 32px;
  color: #323233;
  font-size: 14px;
  text-align: center;
  transform: translateY(-50%);
  cursor: pointer;
  background: rgba(244, 244, 244, 0.39);
}
.person-box {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 16px;
}
.person-box img {
  margin: 0 10px;
}
.person-box-list {
  display: flex;
  /* margin-right: 70px; */
  align-items: center;
}
.person-box-title {
  margin-right: 10px;
}
.resignation-select {
  text-align: left;
  margin-top: 20px;
}
.task-box {
  padding: 0 22px;
  margin-top: 16px;
  margin-right: 25px;
  border: 1px solid #dcdee0;
}
/* 选项卡 */
.task-tab {
  display: flex;
  /* margin: 0 22px; */
  border-bottom: 1px solid #dcdee0;
}
.task-tab span {
  color: #b9b9b9;
  line-height: 50px;
}
.task-list {
  position: relative;
  min-width: 100px;
  color: #7e7e7e;
  text-align: center;
  padding: 16px 0;
  cursor: pointer;
}
.task-list-active::after {
  position: absolute;
  display: block;
  content: '';
  width: 60px;
  height: 4px;
  background: #649fa4;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
/* 客户列表 */
.customer-box {
  display: flex;
  justify-content: space-between;
}
.customer-left {
  width: 368px;
  padding: 24px 21px;
  border-right: 1px solid #dcdee0;
}
.customer-right {
  flex: 1;
  padding-top: 16px;
  padding-left: 19px;
  box-sizing: border-box;
}
.choose-person {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}
.choose-person-left span {
  color: #649fa4;
}
.choose-person-right {
  color: red;
  cursor: pointer;
}
/* 提交 */
.task-submit-box {
  display: flex;
  flex-flow: row-reverse;
  align-items: center;
  padding: 20px 0;
}
.task-submit-box p {
  font-size: 16px;
  margin-right: 25px;
}
.task-submit-box p span {
  color: #649fa4;
}
.task-btn {
  height: 32px;
  line-height: 32px;
  padding: 0 24px;
  margin-right: 25px;
  text-align: center;
  border-radius: 2px;
  cursor: pointer;
}
.task-btn-cancel {
  color: #323233;
  border: 1px solid #dcdee0;
}
.task-btn-sure {
  color: #fff;
  background: #4fa1a4;
}
.search-tab-box {
  display: flex;
  margin-top: 15px;
}
.tip-text {
  text-align: left;
}
</style>
<template>
  <div class="resignation" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="resignation-wrap">
      <div class="resignation-title">
        {{ leaveStaffData.allocateState == 1 ? `${leaveStaffData.staffName}待分配的客户和任务` : '查看详情' }}
        <span @click="$router.go(-1)">返回</span>
      </div>
      <div class="person-box">
        <div class="person-box-list">
          <div class="person-box-title">离职人员：</div>
          <p>
            {{ leaveStaffData.staffName }} {{ leaveStaffData.mobileNo }}
            {{ leaveStaffData.organisationNames ? leaveStaffData.organisationNames.toString() : '' }}
          </p>
        </div>
        <img width="40" height="40" src="../../assets/images/transform.png" alt="" />
        <div class="person-box-list">
          <div class="person-box-title">
            接替人员：<span v-show="leaveStaffData.allocateState !== 1"
              >{{ leaveStaffData.replaceStaffName }} {{ replaceMobileNo }} {{ replaceOrganisationNames }}</span
            >
          </div>
          <el-select
            v-show="leaveStaffData.allocateState == 1"
            class="person-box-content"
            v-model="staffGuid"
            placeholder="请选择"
            filterable
            size="medium"
            v-loading="staffLoading"
          >
            <el-option v-for="item in staffList" :key="item.guid" :label="item.staffName" :value="item.guid">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="task-box" v-if="leaveStaffData.allocateState == 1">
        <!-- 选项卡 -->
        <div class="task-tab">
          <div
            :class="currentTab == index ? 'task-list task-list-active' : 'task-list'"
            v-for="(item, index) in tabList"
            :key="index"
            @click="tabClick(item, index)"
          >
            {{ item.name }}
          </div>
          <span>(提示：将未完成的量分配出去)</span>
        </div>
        <!-- 客户列表 -->
        <div class="customer-box" v-show="currentTab == 0">
          <div class="customer-left">
            <el-input placeholder="输入关键字进行过滤" v-model="filterTextCustomer"> </el-input>
            <el-tree
              class="filter-tree"
              :data="customerList"
              show-checkbox
              :props="defaultProps"
              :filter-node-method="filterNodeCustomer"
              ref="treeCustomer"
              @check="handleNodeClickCustomer"
              node-key="id"
            >
            </el-tree>
          </div>
          <div class="customer-right">
            <div class="choose-person">
              <div class="choose-person-left">
                已选 <span>{{ customerSelectList.length }}</span>
              </div>
              <div class="choose-person-right" @click="delCustomer">批量删除</div>
            </div>
            <el-table
              :data="
                customerSelectList.slice(
                  (pageCustomer.pageIndex - 1) * pageCustomer.pageSize,
                  pageCustomer.pageIndex * pageCustomer.pageSize,
                )
              "
              style="width: 100%"
              @selection-change="handleSelectionChangeCustomer"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="label" label="客户名称" width="180"> </el-table-column>
              <el-table-column prop="venue" label="所在区域" width="180">
                <template slot-scope="scope">
                  {{ scope.row.venue || '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="address" label="详细地址">
                <template slot-scope="scope">
                  {{ scope.row.address || '-' }}
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="pt pb back-color-fff"
              background
              @size-change="handleSizeChangeCustomer"
              @current-change="handleCurrentChangeCustomer"
              :page-sizes="[5, 10, 20, 50, 100]"
              :current-page="pageCustomer.pageIndex"
              :page-size="pageCustomer.pageSize"
              layout="total, sizes, prev, pager, next"
              :total="customerSelectList.length"
            >
            </el-pagination>
          </div>
        </div>
        <!-- 任务列表 -->
        <div class="customer-box" v-show="currentTab == 1">
          <div class="customer-left">
            <el-input placeholder="输入关键字进行过滤" v-model="filterTextTask"> </el-input>
            <el-tree
              class="filter-tree"
              :data="taskList"
              show-checkbox
              :props="defaultProps"
              :filter-node-method="filterNodeTask"
              ref="treeTask"
              @check="handleNodeClickTask"
              node-key="id"
            >
            </el-tree>
          </div>
          <div class="customer-right">
            <div class="choose-person">
              <div class="choose-person-left">
                已选 <span>{{ taskSelectList.length }}</span>
              </div>
              <div class="choose-person-right" @click="delTask">批量删除</div>
            </div>
            <el-table
              :data="
                taskSelectList.slice(
                  (pageTask.pageIndex - 1) * pageTask.pageSize,
                  pageTask.pageIndex * pageTask.pageSize,
                )
              "
              style="width: 100%"
              @selection-change="handleSelectionChangeTask"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="taskTitle" label="任务项目"> </el-table-column>
              <el-table-column prop="taskContentName" label="任务内容"> </el-table-column>
              <el-table-column prop="planCount" label="完成情况" header-align="right" align="right">
                <template slot-scope="scope">
                  {{ scope.row.realCount + '/' + scope.row.planCount }}
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="pt pb back-color-fff"
              background
              @size-change="handleSizeChangeTask"
              @current-change="handleCurrentChangeTask"
              :page-sizes="[10, 20, 50, 100]"
              :current-page="pageTask.pageIndex"
              layout="total, sizes, prev, pager, next"
              :total="taskSelectList.length"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="task-box" v-if="leaveStaffData.allocateState == 2">
        <!-- 选项卡 -->
        <div class="task-tab">
          <div
            :class="currentTab == index ? 'task-list task-list-active' : 'task-list'"
            v-for="(item, index) in tabList"
            :key="index"
            @click="tabClick(item, index)"
          >
            {{ item.name }}
          </div>
        </div>
        <!-- 客户列表-详情 -->
        <div v-show="currentTab == 0">
          <el-row :gutter="24" class="mb15">
            <el-col :span="8" class="search-tab-box">
              <div class="search-area-div w110">客户名称：</div>
              <el-input
                v-model="pageCustomerDetail.customerName"
                class="ipt-sty w70f fl"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-col>
            <el-col :span="16" class="t-left mt15">
              <el-button size="medium" type="info" @click="getCustomerDetailList()">搜索</el-button>
              <el-button size="medium" type="danger" @click="emptyCustomerDetail">清空</el-button>
            </el-col>
          </el-row>
          <el-table :data="customerDetailList" style="width: 100%">
            <el-table-column label="序号" width="60" header-align="center" align="center">
              <template slot-scope="scope">
                {{ (pageCustomerDetail.pageIndex - 1) * pageCustomerDetail.pageSize + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="customerType" label="客户类型" width="180">
              <template slot-scope="scope">
                {{ scope.row.customerType | customerType }}
              </template>
            </el-table-column>
            <el-table-column prop="customerName" label="客户名称" width="180">
              <template slot-scope="scope">
                {{ scope.row.customerName || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="contactTel" label="手机号" width="180">
              <template slot-scope="scope">
                {{ scope.row.contactTel || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="venue" label="所在区域" width="180">
              <template slot-scope="scope">
                {{ scope.row.venue || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="address" label="详细地址">
              <template slot-scope="scope">
                {{ scope.row.address || '-' }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pt pb back-color-fff t-center"
            background
            @size-change="handleSizeChangeCustomerDetail"
            @current-change="handleSizeChangeCustomerDetail"
            :page-sizes="[5, 10, 20, 50, 100]"
            :current-page="pageCustomerDetail.pageIndex"
            :page-size="pageCustomerDetail.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="pageCustomerDetail.totalRows"
          >
          </el-pagination>
        </div>
        <!-- 任务列表-详情 -->
        <div v-show="currentTab == 1">
          <el-row :gutter="24" class="mb15">
            <el-col :span="8" class="search-tab-box">
              <div class="search-area-div w110">任务名称：</div>
              <el-input
                v-model="pageTaskDetail.taskContentName"
                class="ipt-sty w70f"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-col>
            <el-col :span="16" class="t-left mt15">
              <el-button size="medium" type="info" @click="getTaskDetailList()">搜索</el-button>
              <el-button size="medium" type="danger" @click="emptyTaskDetail">清空</el-button>
            </el-col>
          </el-row>
          <el-table :data="taskDetailList" style="width: 100%">
            <el-table-column label="序号" width="60" header-align="center" align="center">
              <template slot-scope="scope">
                {{ (pageTaskDetail.pageIndex - 1) * pageTaskDetail.pageSize + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="taskTitle" label="任务项目"> </el-table-column>
            <el-table-column prop="taskContentName" label="任务名称"> </el-table-column>
            <el-table-column prop="menuName" label="执行功能"> </el-table-column>
            <el-table-column prop="planCount" label="分配目标量" header-align="right" align="right"> </el-table-column>
          </el-table>
          <el-pagination
            class="pt pb back-color-fff t-center"
            background
            @size-change="handleSizeChangeTaskDetail"
            @current-change="handleCurrentChangeTaskDetail"
            :page-sizes="[10, 20, 50, 100]"
            :current-page="pageTaskDetail.pageIndex"
            :page-size="pageTaskDetail.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="pageTaskDetail.totalRows"
          >
          </el-pagination>
        </div>
      </div>
      <div class="task-submit-box" v-if="leaveStaffData.allocateState == 1">
        <div class="task-btn task-btn-cancel" @click="$router.go(-1)">取消</div>
        <div class="task-btn task-btn-sure" @click="submitPage">确认变更</div>
        <p>
          已选<span>{{ customerSelectList.length }}</span
          >个客户，<span>{{ taskSelectList.length }}</span
          >个任务
        </p>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :show-close="false"
      width="422px"
    >
      <div slot="title" class="t-left font-S20">提示</div>
      <span class="tip-text">{{ replaceTip }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipClick">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabList: [
        {
          name: '客户列表',
          value: '0',
        },
        {
          name: '任务列表',
          value: '1',
        },
      ],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
      },
      pageTask: {
        pageIndex: 1,
        pageSize: 10,
      },
      pageCustomer: {
        pageIndex: 1,
        pageSize: 10,
      },
      currentTab: 0,
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      //客户列表
      customerList: [],
      customerSelectList: [],
      customerDelList: [],
      filterTextCustomer: '',
      customerDetailList: [],
      leaveStaffData: '', //离职人员信息
      pageCustomerDetail: {
        customerName: null,
        pageIndex: 1,
        pageSize: 10,
        dutyTransformGuid: null,
        totalPage: 0,
        totalRows: 0,
      },
      //任务列表
      taskList: [],
      taskSelectList: [],
      taskDelList: [],
      filterTextTask: '',
      taskDetailList: [],
      pageTaskDetail: {
        taskContentName: null,
        pageIndex: 1,
        pageSize: 10,
        dutyTransformGuid: null,
        totalPage: 0,
        totalRows: 0,
      },
      replaceTip: '',
      dialogVisible: false,
      //接替人员
      staffList: [],
      staffGuid: '',
      staffLoading: false,
      fullscreenLoading: false,
      replaceOrganisationNames: '',
      replaceMobileNo: '',
    };
  },
  watch: {
    filterTextTask(val) {
      this.$refs.treeTask.filter(val);
    },
    filterTextCustomer(val) {
      this.$refs.treeCustomer.filter(val);
    },
  },
  created() {
    if (localStorage.leaveStaffData) {
      this.leaveStaffData = JSON.parse(localStorage.leaveStaffData);
    }
    this.getTaskList();
    this.getCustomerList();
    if (this.leaveStaffData.guid) {
      this.getCustomerDetailList();
      this.getTaskDetailList();
      this.getStaffDetail();
      // this.getDetail();
    } else {
      this.getStaff();
    }
  },
  methods: {
    filterNodeTask(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    filterNodeCustomer(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    tabClick(item, index) {
      this.currentTab = index;
    },
    getDetail() {
      return new Promise((resolve, reject) => {
        this.fullscreenLoading = true;
        this.api
          .get(`/${serverConfig.msUserRemunerationService}/duty-transform/detail?guid=${this.leaveStaffData.guid}`)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              let data = res.data.data;
              this.staffGuid = data.staffGuid;
              this.fullscreenLoading = false;
              if (data.staffTaskDetailGuids) {
                this.$refs.treeTask.setCheckedKeys(data.staffTaskDetailGuids);
                this.handleNodeClickTask();
              }
              let customerArr = [];
              if (data.franchiseeGuids) {
                customerArr = data.franchiseeGuids;
              }
              if (data.doctorGuids) {
                customerArr = customerArr.cancat(data.doctorGuids);
              }
              if (data.patientGuids) {
                customerArr = customerArr.cancat(data.patientGuids);
              }
              if (data.medGuids) {
                customerArr = customerArr.cancat(data.medGuids);
              }
              if (data.customer) {
                customerArr = customerArr.cancat(data.customer);
              }
              if (data.potentialCustomer) {
                customerArr = customerArr.cancat(data.potentialCustomer);
              }
              if (data.potentialFranchisees) {
                customerArr = customerArr.cancat(data.potentialFranchisees);
              }
              if (customerArr.length > 0) {
                this.$refs.treeCustomer.setCheckedKeys(customerArr);
                this.handleNodeClickCustomer();
              }
              this.staffLoading = false;
              resolve();
            } else {
              this.$message.error(res.data.msg);
            }
          });
      });
    },
    //获取人员信息
    getStaffDetail() {
      this.api
        .get(
          `/${serverConfig.msPersonnelService}/staff/data/get-staff-detail?guid=${this.leaveStaffData.replaceStaffGuid}`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = res.data.data;
            this.replaceOrganisationNames = data.organisationNames.toString();
            this.replaceMobileNo = data.mobileNo;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //详情客户列表
    getCustomerDetailList() {
      this.pageCustomerDetail.pageIndex = 1;
      this.pageCustomerDetail.dutyTransformGuid = this.leaveStaffData.guid;
      this.api
        .postJson(
          `/${serverConfig.msUserRemunerationService}/duty-transform/allocate-customer-list`,
          this.pageCustomerDetail,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data.records) {
              this.customerDetailList = res.data.data.records;
            } else {
              this.customerDetailList = [];
            }
            this.pageCustomerDetail.totalPage = res.data.data.totalPages;
            this.pageCustomerDetail.totalRows = res.data.data.totalRows;
            this.fullscreenLoading = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    emptyCustomerDetail() {
      this.pageCustomerDetail = {
        customerName: null,
        pageIndex: 1,
        pageSize: 10,
        dutyTransformGuid: null,
        totalPage: 0,
        totalRows: 0,
      };
      this.getCustomerDetailList();
    },
    //详情任务列表
    getTaskDetailList() {
      this.pageTaskDetail.pageIndex = 1;
      this.pageTaskDetail.dutyTransformGuid = this.leaveStaffData.guid;
      this.api
        .postJson(`/${serverConfig.msUserRemunerationService}/duty-transform/allocate-task-list`, this.pageTaskDetail)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data.records) {
              this.taskDetailList = res.data.data.records;
            } else {
              this.taskDetailList = [];
            }
            this.pageTaskDetail.totalPage = res.data.data.totalPages;
            this.pageTaskDetail.totalRows = res.data.data.totalRows;
            this.fullscreenLoading = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    emptyTaskDetail() {
      this.pageTaskDetail = {
        taskContentName: null,
        pageIndex: 1,
        pageSize: 10,
        dutyTransformGuid: null,
        totalPage: 0,
        totalRows: 0,
      };
      this.getTaskDetailList();
    },
    getStaff() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        bizState: 'Y',
        tenantGuid: this.leaveStaffData.tenantGuid,
      };
      this.fullscreenLoading = true;
      // this.staffLoading = true;
      return new Promise((resolve, reject) => {
        self.api.get(`/${serverConfig.msPersonnelService}/staff/get-staff-by-tenantGuid?staffInfo=&tenantGuid=${this.leaveStaffData.tenantGuid}`).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.staffList = res.data.data;
            // self.staffLoading = false;
            this.fullscreenLoading = false;
            resolve();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      });
    },
    //获取客户列表
    getCustomerList() {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let query = {
        tenantGuid: this.leaveStaffData.tenantGuid,
        staffGuid: [this.leaveStaffData.staffGuid],
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/duty-transform/get-customer`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data;
          //客户
          if (data && data.customer && data.customer.length > 0) {
            let customerObj = {
              id: 'customer',
              label: '客户',
              children: [],
            };
            self.customerList.push(customerObj);
            data.customer.forEach((a) => {
              a.id = a.guid;
              a.label = a.customerName;
              a.type = 'customer';
            });
            self.customerList.forEach((aa) => {
              if (aa.id == 'customer') {
                aa.children = data.customer;
              }
            });
          }
          //医生
          if (data && data.doctors && data.doctors.length > 0) {
            let doctorsObj = {
              id: 'doctors',
              label: '医生',
              children: [],
            };
            self.customerList.push(doctorsObj);
            data.doctors.forEach((a) => {
              a.id = a.guid;
              a.label = a.doctorName;
              a.type = 'doctors';
            });
            self.customerList.forEach((aa) => {
              if (aa.id == 'doctors') {
                aa.children = data.doctors;
              }
            });
          }
          //商业公司
          if (data && data.franchisees && data.franchisees.length > 0) {
            let franchiseesObj = {
              id: 'franchisees',
              label: '商业公司',
              children: [],
            };
            self.customerList.push(franchiseesObj);
            data.franchisees.forEach((a) => {
              a.id = a.guid;
              a.label = a.franchiseeName;
              a.type = 'franchisees';
            });
            self.customerList.forEach((aa) => {
              if (aa.id == 'franchisees') {
                aa.children = data.franchisees;
              }
            });
          }
          //医院
          if (data && data.medList && data.medList.length > 0) {
            let medListObj = {
              id: 'medList',
              label: '医院',
              children: [],
            };
            self.customerList.push(medListObj);
            data.medList.forEach((a) => {
              a.id = a.guid;
              a.label = a.medName;
              a.type = 'medList';
            });
            self.customerList.forEach((aa) => {
              if (aa.id == 'medList') {
                aa.children = data.medList;
              }
            });
          }
          //患者
          if (data && data.patients && data.patients.length > 0) {
            let patientsObj = {
              id: 'patients',
              label: '患者',
              children: [],
            };
            self.customerList.push(patientsObj);
            data.patients.forEach((a) => {
              a.id = a.guid;
              a.label = a.patientName;
              a.type = 'patients';
            });
            self.customerList.forEach((aa) => {
              if (aa.id == 'patients') {
                aa.children = data.patients;
              }
            });
          }
          //潜在客户
          if (data && data.potentialCustomer && data.potentialCustomer.length > 0) {
            let potentialCustomerObj = {
              id: 'potentialCustomer',
              label: '潜在客户',
              children: [],
            };
            self.customerList.push(potentialCustomerObj);
            data.potentialCustomer.forEach((a) => {
              a.id = a.guid;
              a.label = a.customerName;
              a.type = 'potentialCustomer';
            });
            self.customerList.forEach((aa) => {
              if (aa.id == 'potentialCustomer') {
                aa.children = data.potentialCustomer;
              }
            });
          }
          //潜在商业公司
          if (data && data.potentialFranchisees && data.potentialFranchisees.length > 0) {
            let potentialFranchiseesObj = {
              id: 'potentialFranchisees',
              label: '潜在商业公司',
              children: [],
            };
            self.customerList.push(potentialFranchiseesObj);
            data.potentialFranchisees.forEach((a) => {
              a.id = a.guid;
              a.label = a.franchiseeName;
              a.type = 'potentialFranchisees';
            });
            self.customerList.forEach((aa) => {
              if (aa.id == 'potentialFranchisees') {
                aa.children = data.potentialFranchisees;
              }
            });
          }
          self.customerList = self.customerList.filter((l) => {
            return l.children.length > 0;
          });
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取任务列表
    getTaskList() {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let query = {
        pageIndex: 1,
        serviceTenantGuid: this.leaveStaffData.tenantGuid,
        pageSize: -1,
        staffGuids: [this.leaveStaffData.staffGuid],
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/duty-transform/leave-staff-task-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.taskList = self.toTree(res.data.data.records);
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    unique(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.taskMainGuid) && res.set(arr.taskMainGuid, 1));
    },
    //数组转树结构
    toTree(arr) {
      let newArr = [];
      let arrList = [];
      arr.forEach((i, index) => {
        let item = {
          label: i.taskTitle,
          taskMainGuid: i.taskMainGuid,
          children: [],
        };
        arrList.push(item);
      });
      arrList = this.unique(arrList);
      arrList.forEach((m, index) => {
        m.id = 'xxxy' + m.taskMainGuid;
        arr.forEach((n, index1) => {
          if (m.taskMainGuid == n.taskMainGuid) {
            let items = n;
            items.id = n.guid;
            items.label = n.taskContentName;
            m.children.push(items);
          }
        });
      });
      return arrList;
    },
    //批量删除任务
    delTask() {
      this.taskDelList.forEach((j) => {
        this.taskSelectList.forEach((i, index) => {
          if (i.id == j) {
            this.taskSelectList.splice(index, 1);
          }
        });
      });
      this.$refs.treeTask.setCheckedNodes(this.taskSelectList);
    },
    delCustomer() {
      this.customerDelList.forEach((j) => {
        this.customerSelectList.forEach((i, index) => {
          if (i.id == j) {
            this.customerSelectList.splice(index, 1);
          }
        });
      });
      this.$refs.treeCustomer.setCheckedNodes(this.customerSelectList);
    },
    //页面提交
    submitPage() {
      if (!this.staffGuid) {
        this.$message.error('接替人员选择不能为空');
        return;
      }
      if (!this.taskSelectList.length && !this.customerSelectList.length) {
        this.$message.error('请选择客户列表或任务列表');
        return;
      }
      let query = {
        guid: this.leaveStaffData.guid,
        tenantGuid: this.leaveStaffData.tenantGuid,
        staffGuid: this.leaveStaffData.staffGuid,
        userGuid: this.leaveStaffData.userGuid,
        staffName: this.leaveStaffData.staffName,
        replaceStaffGuid: '',
        replaceUserGuid: '',
        replaceStaffName: '',
        doctors: [],
        patients: [],
        franchisees: [],
        potentialFranchisees: [],
        customer: [],
        potentialCustomer: [],
        medList: [],
        tasks: [],
      };
      let department = '';
      this.staffList.forEach((i) => {
        if (i.guid == this.staffGuid) {
          query.replaceStaffGuid = i.guid;
          query.replaceUserGuid = i.userGuid;
          query.replaceStaffName = i.staffName;
          department = i.organisationNames;
        }
      });
      if (this.taskSelectList.length > 0) {
        let taskSelectList = JSON.parse(JSON.stringify(this.taskSelectList));
        this.taskSelectList.forEach((a) => {
          delete a.id;
          delete a.label;
          query.tasks.push(a);
        });
      }
      if (this.customerSelectList.length > 0) {
        let customerSelectList = JSON.parse(JSON.stringify(this.customerSelectList));
        customerSelectList.forEach((m) => {
          delete m.id;
          delete m.label;
          //医生
          if (m.type == 'doctors') {
            query.doctors.push(m);
          }
          //患者
          if (m.type == 'patients') {
            query.patients.push(m);
          }
          //商业公司
          if (m.type == 'franchisees') {
            query.franchisees.push(m);
          }
          //潜在商业公司
          if (m.type == 'potentialFranchisees') {
            query.potentialFranchisees.push(m);
          }
          //客户
          if (m.type == 'customer') {
            query.customer.push(m);
          }
          //潜在客户
          if (m.type == 'potentialCustomer') {
            query.potentialCustomer.push(m);
          }
          //医院
          if (m.type == 'medList') {
            query.medList.push(m);
          }
        });
      }
      console.log(query);
      this.$confirm(`转出不可逆，确定转出给【${department}】的【${query.replaceStaffName}】吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.fullscreenLoading = true;
        this.api.postJson(`/${serverConfig.msUserRemunerationService}/duty-transform/allocate`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (this.customerSelectList.length > 0 && this.taskSelectList.length > 0) {
              this.replaceTip = `已成功转出【${this.customerSelectList.length}】个客户 和 【${this.taskSelectList.length}】个任务给【${query.replaceStaffName}】哦～`;
            } else if (this.customerSelectList.length > 0 && this.taskSelectList.length == 0) {
              this.replaceTip = `已成功转出【${this.customerSelectList.length}】个客户给【${query.replaceStaffName}】哦～`;
            } else if (this.customerSelectList.length == 0 && this.taskSelectList.length > 0) {
              this.replaceTip = `已成功转出【${this.taskSelectList.length}】个任务给【${query.replaceStaffName}】哦～`;
            }
            this.$alert(this.replaceTip, '提示', {
              confirmButtonText: '我知道了',
              type: 'success',
              showClose:false,
              callback: action => {
                this.$router.go(-1);
              }
            });
            this.fullscreenLoading = false;
          } else {
            this.$message.error(res.data.msg);
            this.fullscreenLoading = false;
          }
        });
      });
    },
    tipClick() {
      this.dialogVisible = false;
      this.$router.go(-1);
    },
    //客户选择
    handleNodeClickCustomer(data) {
      this.customerSelectList = this.$refs.treeCustomer.getCheckedNodes(true);
      this.$forceUpdate();
    },
    //任务选择
    handleNodeClickTask(data) {
      this.taskSelectList = this.$refs.treeTask.getCheckedNodes(true);
      this.$forceUpdate();
    },
    handleSelectionChangeCustomer(val) {
      if (val && val.length) {
        val.forEach((i) => {
          this.customerDelList.push(i.id);
        });
      }
      console.log(val);
    },
    handleSizeChangeCustomer(val) {
      let self = this;
      self.pageCustomer.pageSize = val;
    },
    handleCurrentChangeCustomer(val) {
      let self = this;
      self.pageCustomer.pageIndex = val;
    },
    handleSelectionChangeTask(val) {
      if (val && val.length) {
        val.forEach((i) => {
          this.taskDelList.push(i.id);
        });
      }
      console.log(val);
    },
    handleSizeChangeTask(val) {
      let self = this;
      self.pageTask.pageSize = val;
    },
    handleCurrentChangeTask(val) {
      let self = this;
      self.pageTask.pageIndex = val;
    },

    handleSizeChangeTaskDetail(val) {
      let self = this;
      self.pageTaskDetail.pageSize = val;
    },
    handleCurrentChangeTaskDetail(val) {
      let self = this;
      self.pageTaskDetail.pageIndex = val;
    },
    handleSizeChangeCustomerDetail(val) {
      let self = this;
      self.pageCustomerDetail.pageSize = val;
    },
    handleCurrentChangeCustomeDetail(val) {
      let self = this;
      self.pageCustomerDetail.pageIndex = val;
    },
  },
};
</script>
